const wowApp = require('angular').module('wowApp.wallet');

const giftCardAmountValidationDirective = require('./gift-card-amount-validation.directive');
const giftCardBalanceValidationDirective = require('./gift-card-balance-validation.directive');
const giftCardNumberValidationDirective = require('./gift-card-number-validation.directive');
const restrictPartialAlphaDirective = require('./restrict-partial-alpha.directive');

const { giftCardAddBaseComponentDefinition } = require('./gift-card-add-base.component');
const { giftCardItemComponentDefinition } = require('./gift-card-item.component');

wowApp.directive('wowGiftCardAmountValidation', giftCardAmountValidationDirective);
wowApp.directive('wowGiftCardBalanceValidation', giftCardBalanceValidationDirective);
wowApp.directive('wowGiftCardNumberValidation', giftCardNumberValidationDirective);
wowApp.directive('restrictPartialAlpha', restrictPartialAlphaDirective);
wowApp.component('wowGiftCardAddBase', giftCardAddBaseComponentDefinition);
wowApp.component('wowGiftCardItem', giftCardItemComponentDefinition);



// WEBPACK FOOTER //
// ./src/wallet/giftcard/index.js